import React from "react";

const ProfileHead = () => {
  return (
    <>
      <div className="d_flx prf_head">
        <div>
          <h1>Profile</h1>
          <p>Edit your personal details</p>
        </div>  
      </div>
    </>
  );
};
export default ProfileHead;
